import ShiftInventory from './ShiftInventory';

export default ShiftInventory;
